import { useEffect, useState } from 'react';
import ReactParallaxTilt, { type ReactParallaxTiltProps } from 'react-parallax-tilt';

// `app/24/Tilt.js` — react-parallax-tilt with the tilt turned off below md, where there
// is no pointer to track. The breakpoint is read from `window.innerWidth` rather than a
// media query, exactly as over there, so the two behave identically on resize.
export default function Tilt(props: ReactParallaxTiltProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return <ReactParallaxTilt {...props} tiltEnable={!isMobile} />;
}
